import smoothscroll from "smoothscroll-polyfill";
import SmoothScroll from "smooth-scroll";

export function smooth() {
  smoothscroll.polyfill();
  const anchorSt = document.querySelector('.js-anchorSt');
  const anchorSt_h = anchorSt.getBoundingClientRect().height;
  console.log(anchorSt_h);

  const scroll = new SmoothScroll('a[href*="#"]', {
    header: "#header",
    speed: 300,
    updateURL: false,
    offset: () => {
      const anchorSt = document.querySelector('.js-anchorSt');
      return anchorSt ? anchorSt.getBoundingClientRect().height : 0;
    }
  });
}